import React from "react";
// ANT DESIGN COMPONENTS
import { Modal, Input, Form } from "antd";
// I18N TRANSLATION
import { useTranslation } from "react-i18next";
// INTERFACES
import { ServerInterface } from "../../../interfaces/Server.interface";

interface ServerSmtpModalProps {
	open: boolean;
	server: ServerInterface;
	formAction: "create" | "edit";
	onChangeSmtpValue: (newValue: string, variableName: string) => void;
	onClose: () => void;
}

function ServerSmtpModal({ open, server, formAction, onChangeSmtpValue, onClose }: ServerSmtpModalProps) {
	// ************************************************ */
	// GLOBAL VARIABLES ******************************* */
	const [t] = useTranslation("global");

	// ************************************************ */
	// COMPONENT ************************************** */
	return (
		<Modal
			title='SMTP Configuration'
			open={open}
			onOk={onClose}
			onCancel={onClose}
			okText={t("general.accept")}
			cancelButtonProps={{ style: { display: "none" } }}
			destroyOnClose
		>
			<Form layout='vertical' className='mt-3'>
				<Form.Item label='SMTP Host'>
					<Input
						placeholder='smtp.example.com'
						value={server.smtp_host}
						onChange={(e) => onChangeSmtpValue(e.target.value, "smtp_host")}
						disabled={formAction !== "create" && formAction !== "edit"}
					/>
				</Form.Item>
				<Form.Item label='SMTP Port'>
					<Input
						placeholder='587'
						value={server.smtp_port}
						onChange={(e) => onChangeSmtpValue(e.target.value, "smtp_port")}
						disabled={formAction !== "create" && formAction !== "edit"}
					/>
				</Form.Item>
				<Form.Item label='SMTP User'>
					<Input
						placeholder='user@example.com'
						value={server.smtp_user}
						onChange={(e) => onChangeSmtpValue(e.target.value, "smtp_user")}
						disabled={formAction !== "create" && formAction !== "edit"}
					/>
				</Form.Item>
				<Form.Item label='SMTP Password'>
					<Input.Password
						placeholder='********'
						value={server.smtp_pass}
						onChange={(e) => onChangeSmtpValue(e.target.value, "smtp_pass")}
						disabled={formAction !== "create" && formAction !== "edit"}
					/>
				</Form.Item>
				<Form.Item label='SMTP From'>
					<Input
						placeholder='noreply@example.com'
						value={server.smtp_from}
						onChange={(e) => onChangeSmtpValue(e.target.value, "smtp_from")}
						disabled={formAction !== "create" && formAction !== "edit"}
					/>
				</Form.Item>
			</Form>
		</Modal>
	);
}

export default ServerSmtpModal;
